import React, { Component, Fragment } from 'react';
import { Grid, Checkbox } from 'semantic-ui-react';
import _ from 'lodash';

import { TitledCard } from 'Components/';
import ReactTable from 'Common/ReactTableWrapper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';

class MealSummaries extends Component {
  onToggleAll = () => {
    return _.every(this.props.data, { IsSelected: true });
  };

  columns = [
    {
      Header: ({ original }) => {
        return (
          <div style={{ textAlign: 'center' }}>
            <Checkbox
              checked={this.onToggleAll()}
              onChange={(e, data) => {
                this.props.onChangeAll(data);
              }}
            />
          </div>
        );
      },
      accessor: 'IsSelected',
      sortable: false,
      maxWidth: 70,
      Cell: ({ original }) => {
        if (!original.UserName) return null;
        return (
          <div style={{ textAlign: 'center' }}>
            <Checkbox
              checked={original.IsSelected}
              onChange={(e, data) => {
                this.props.onChange(original);
              }}
            />
          </div>
        );
      },
    },
    {
      Header: 'Closing Date',
      accessor: 'ClosingDate',
      filterable: true,
      minWidth: 70,
    },
    {
      Header: 'Type',
      accessor: 'MealType',
      filterable: true,
      minWidth: 150,
    },
    {
      Header: 'User',
      accessor: 'UserName',
      filterable: true,
      minWidth: 70,
    },
  ];

  render() {
    const { data } = this.props;
    return (
      <Fragment>
        <TitledCard title="To delete an associated Meal Summary, check below.">
          <Grid columns={1}>
            <Grid.Row>
              <ReactTable
                saveState={{
                  tableName: TableNamesEnum.UNCLOSEDAY_MEAL_SUMMARY_TABLE,
                }}
                loading={this.props.loading}
                data={data}
                columns={this.columns}
              />
            </Grid.Row>
          </Grid>
        </TitledCard>
      </Fragment>
    );
  }
}

export { MealSummaries };



// WEBPACK FOOTER //
// ./src/pages/uncloseday/components/MealSummaries.js